<script>
	import { page } from '$app/stores';
</script>

<div class="h-[70px] bg-secondary-400"></div>
<header class="flex items-center justify-center">
	<!-- <h1 class="mt-12 text-3xl text-white">{$page.data.page.title}</h1> -->
</header>
